import './App.css';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import { Home } from './pages/index';
import { Routes, Route } from 'react-router-dom';
import Cake from './pages/Cake';

function App() {
  return (
    <div className="App">
      <Navbar/>
      <br/>
      <br/>
      <br/>
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/cakes/:cakeId" element={<Cake/>} />
      </Routes>
      <Footer/>
    </div>
  );
}

export default App;
